<template>
  <div class="page">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="50%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('house.input')"
      class-name="vertical-center-modal"
      @on-cancel="handlerClose"
    >
      <div class="step-box">
        <Steps :current="1" status="process" class="margin-bottom-20">
          <Step
            :title="$t('house.importTip')"
            :content="$t('house.successFile')"
          ></Step>
          <Step
            :title="$t('house.importTip1')"
            :content="$t('house.picContent')"
          ></Step>
        </Steps>
      </div>
      <div class="cir-box">
        <div class="cir-margin-left">
          <i-circle
            :percent="100"
            stroke-color="#5cb85c"
            :trail-width="4"
            :stroke-width="5"
            :size="200"
          >
            <div class="import-cir">
              <Icon
                type="ios-checkmark"
                size="60"
                style="color: #5cb85c"
              ></Icon>
              <span>{{ "100%" }}</span>
            </div>
          </i-circle>
        </div>
        <div class="cir-margin-right">
          <i-circle
            :percent="0"
            stroke-color="#5cb85c"
            :trail-width="4"
            :stroke-width="5"
            :size="200"
          >
            <div class="import-cir">
              <span class="cir-span">{{ picNum }}</span>
            </div>
          </i-circle>
          <form id="uploadImg">
            <div class="form-box margin-bottom-20 cir-btn">
              <Button type="primary" class="file"
                >{{ $t("house.upLoadBtn") }}
                <input
                  id="file-uploader"
                  type="file"
                  name="facePic"
                  accept=".jpg,.jpeg"
                  @change="showPic($event)"
                  multiple
              /></Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
    <div class="content_win"></div>
  </div>
</template>

<script>
export default {
  name: "ModalBox",
  props: {},
  data() {
    return {
      dialogVisible: false,
      picNum: "0%",
      houseList: [],
      picListLength: 0,
    };
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          document.getElementById("uploadImg").reset();
          document.getElementById("file-uploader").value = "";
          // 弹窗关闭 清空数据
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.dialogVisible = false;
    },
    resetModal() {
      this.$Message.error(this.$t("house.imgCheckTip"));
      this.houseList = [];
      document.getElementById("uploadImg").reset();
      document.getElementById("file-uploader").value = "";
    },
    showPic($event) {
      let el = $event.currentTarget;
      let fileList = el.files;
      let fileLength = fileList.length;
      if (Number(fileLength) > Number(this.picListLength)) {
        //    上传的图片大于
        this.$Message.error(this.$t("house.picNumMax"));
        document.getElementById("uploadImg").reset();
        document.getElementById("file-uploader").value = "";
        return;
      } else if (Number(fileLength) < Number(this.picListLength)) {
        //    上传的图片小于
        this.$Message.error(this.$t("house.picNumMin"));
        document.getElementById("uploadImg").reset();
        document.getElementById("file-uploader").value = "";
        return;
      } else if (Number(fileLength) === Number(this.picListLength)) {
        // 限制上传大小
        let sizeFlag = false;
        let nameFlag = false;
        let typeFlag = false;
        if (fileLength > 0) {
          for (let i in fileList) {
            if (typeof fileList[i] === "object") {
              let fileSize = fileList[i].size;
              if (fileSize > 1024 * 1024 * 10) {
                sizeFlag = true;
              }

              // 名称中文校验
              let val = fileList[i].name;
              let nameExp = /[\u4E00-\u9FA5]/g;
              if (nameExp.test(val)) {
                nameFlag = true;
              }

              // 检验格式
              let lastName = fileList[i].name.split(".").reverse()[0];
              let allowPicReg = ["jpg", "jpeg"];
              if (!allowPicReg.includes(lastName)) {
                typeFlag = true;
              }
            }
          }
        }

        // 名称中文 报错
        if (nameFlag) {
          this.$Message.error(this.$t("house.imgName"));
          document.getElementById("uploadImg").reset();
          document.getElementById("file-uploader").value = "";
          return;
        }
        // 图片格式 报错
        if (typeFlag) {
          this.$Message.error(this.$t("house.imgRegTip"));
          document.getElementById("uploadImg").reset();
          document.getElementById("file-uploader").value = "";
          return;
        }
        if (fileLength > 0 && sizeFlag) {
          this.$Message.error(this.$t("house.imgSize"));
          document.getElementById("uploadImg").reset();
          document.getElementById("file-uploader").value = "";
          return;
        } else if (fileLength > 8) {
          //   限制上传总数
          this.$Message.error(this.$t("house.imgLength"));
          let addList = [];

          for (let i in fileList) {
            if (typeof fileList[i] === "object") {
              let url = this.$common.getImgUrl(fileList[i]);
              let obj = {
                file: fileList[i],
                url: url,
                fileName: fileList[i].name.substring(
                  0,
                  fileList[i].name.lastIndexOf(".")
                ),
              };
              addList.push(obj);
            }
          }
          this.houseList = addList.slice(0, 8);

          this.$emit("getList", this.houseList);
        } else {
          for (let i in fileList) {
            if (typeof fileList[i] === "object") {
              let url = this.$common.getImgUrl(fileList[i]);
              let obj = {
                file: fileList[i],
                url: url,
                fileName: fileList[i].name.substring(
                  0,
                  fileList[i].name.lastIndexOf(".")
                ),
              };
              this.houseList.push(obj);
            }
          }

          this.$emit("getList", this.houseList);
        }
      }
    },
    handlerClose() {
      this.$emit("resetList");
    },
  },
};
</script>
